/***
 * Created on 2023/7/13
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useCallback, useEffect, useRef, useState} from 'react';
import ModalDialog from "../common/modal_dialog/modalDialog";
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import {QueryClient, useMutation} from "@tanstack/react-query";
import {apiPost} from "../../service/api";
import {useTranslation} from "react-i18next";
import ContentLoader from "../common/content_loader";


const queryClient = new QueryClient();

function AvatarUploadModal(props) {
    const uploadFile = useRef(null);
    const [avatarImage, setAvatarImage] = useState();
    const [completedCrop, setCompletedCrop] = useState();
    const [crop, setCrop] = useState({ unit: '%', aspect: 1});
    const [showLoading, setShowLoading] = useState(false);
    const imgRef = useRef();
    const modalRef = useRef();
    const { t } = useTranslation();

    const mutation = useMutation({
        mutationFn: (data) => apiPost('/ajax/avatar', data, 'form-data'),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['profile']
            });
            props.closeModal();
        }
    })

    const onOpenFileUpload = () => {
        uploadFile.current.click();
    }

    const onLoad = useCallback((img) => {
        imgRef.current = img;
    }, []);

    const onFileChange = (e) => {
        e.stopPropagation();
        e.preventDefault();
        const file = uploadFile.current.files[0];
        if (file) {
            setAvatarImage(URL.createObjectURL(file));
        }
        console.log(file);
    }

    const uploadAvatar = async () => {
        const scaleX = imgRef.current.naturalWidth / imgRef.current.width;
        const scaleY = imgRef.current.naturalHeight / imgRef.current.height;
        const x1 = completedCrop?.x ? completedCrop.x * scaleX : 25;
        const y1 = completedCrop?.y ? completedCrop.y * scaleY : 25;

        const form = new FormData();
        form.append('avatar_file', uploadFile.current.files[0]);
        form.append('origin_w', Math.floor(imgRef.current.naturalWidth));
        form.append('origin_h', Math.floor(imgRef.current.naturalHeight));
        form.append('x1', x1);
        form.append('y1', y1);
        // if no crop let backend handle the size
        if (completedCrop?.width) {
            form.append('x2', x1 + completedCrop.width * scaleX);
            form.append('y2', y1 + completedCrop.height * scaleY);
        }

        console.log(completedCrop);
        console.log(crop);

        setShowLoading(true);
        await mutation.mutateAsync(form);
        setShowLoading(false);
    }

    useEffect(() => {
        if (uploadFile?.current?.files && uploadFile?.current?.files?.length > 0) {
            modalRef.current.disableSubmitButton(false);
        }

    }, [uploadFile?.current?.files])

    return (
        <ModalDialog
            showModal={props.showModal}
            closeModal={props.closeModal}
            title={t('@Profile Avatar@')}
            submitText={t('@Upload@')}
            submitAction={uploadAvatar}
            initDisableSubmit={true}
            ref={modalRef}
        >
            <>
                {showLoading && <ContentLoader />}
                <div className="dialog-content dialog-content--avatar">
                    <p>{t('@If you have a QNAP Profile picture then it is always visible to everyone.@')}</p>
                    <p className="text-remind">{t('@Maximum upload file size: {{maxFileSize}} MB@', {maxFileSize: 5})}</p>
                    <div className="avatar-container">
                        <ReactCrop
                            aspect="1"
                            // minHeight={100}
                            crop={crop}
                            onChange={(c,p) => setCrop(p)}
                            onComplete={c => setCompletedCrop(c)}
                        >
                            <img src={avatarImage} ref={imgRef} alt=""/>
                        </ReactCrop>
                    </div>
                    <button className="q-btn q-btn--default btn-rounded-full btn-browse" onClick={onOpenFileUpload}>{t('@Select from computer@')}</button>
                    <input type='file' accept="image/*" ref={uploadFile} className='hide' onChange={(e)=>onFileChange(e)}/>

                    {mutation.isError ? (
                        <div>An error occurred: {mutation.error.message}</div>
                    ) : null}

                    {mutation.isSuccess ? <div>Avatar Uploaded!</div> : null}
                </div>
            </>
        </ModalDialog>
    );
}

export default AvatarUploadModal;